module.exports = __webpack_public_path__ + "static/media/p5_bkg.20308880.png";